import { render, staticRenderFns } from "./orderPrintDeliver.vue?vue&type=template&id=6c888426&scoped=true"
import script from "./orderPrintDeliver.vue?vue&type=script&lang=js"
export * from "./orderPrintDeliver.vue?vue&type=script&lang=js"
import style0 from "./orderPrintDeliver.vue?vue&type=style&index=0&id=6c888426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c888426",
  null
  
)

export default component.exports